import ApplyMembershipModal from "../../components/ApplyMembershipModal";

const NEEDS = [
  ["Company", "The named portfolio company you hold."],
  ["Size", "Roughly how many units or dollars, if you know. Optional."],
  ["Price", "An asking level, if you have one. Optional."],
];

export function MembershipSellers({ onSend }) {
  return (
    <>
      <section className="hairline py-16 rise" data-testid="membership-sellers">
        <span className="t-label">For sellers</span>
        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-16 mt-4 items-start">
          <div>
            <h2 className="text-bone measure" style={{ fontSize: "clamp(22px, 2.6vw, 30px)", lineHeight: 1.3, fontWeight: 400 }}>
              Hold a position you want to sell down?
            </h2>
            <p className="t-small text-muted-s mt-5 measure">
              We buy part of a position, not all of it. We read the stock purchase agreement before any price
              is discussed and obtain written confirmation from the company or its transfer agent that a
              transfer would be recognized on its books. We will not proceed without it.
            </p>
            <div className="mt-8">
              <button className="btn-primary inline-block" onClick={onSend} data-testid="membership-send-deal">Send us your deal</button>
            </div>
          </div>
          <div className="gapped-enclosure p-6 sm:p-8" data-testid="membership-sellers-card">
            <span className="t-label">What we need</span>
            <div className="mt-4 space-y-0">
              {NEEDS.map(([k, v]) => (
                <div key={k} className="hairline py-4 flex gap-6 first:border-t-0 first:pt-0">
                  <span className="t-label w-24 shrink-0">{k}</span>
                  <span className="t-small text-muted-s">{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="hairline py-16 rise flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6" data-testid="membership-apply-cta">
        <div>
          <span className="t-label">By invitation</span>
          <p className="t-small text-muted-s mt-2 measure">
            Solera is a private membership. Apply and every application is reviewed by hand.
          </p>
        </div>
        <ApplyMembershipModal trigger={
          <button className="btn-primary inline-block shrink-0" data-testid="membership-footer-apply">Apply for membership</button>
        } />
      </section>
    </>
  );
}
